var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"w-full h-full border-0",attrs:{"src":'https://dpd.talentprint.com/assessments/update/'+_vm.autoLoginToken}})])}
var staticRenderFns = []

export { render, staticRenderFns }